import query from './query'
import config from './config'
import { getUserInfo, getWxSdkToken } from '../api/wxconfig'
import { Toast } from 'antd-mobile'


// 微信授权
const authorization = () => {
    return new Promise(async(resolve, reject) => {
        // 本地没有用户授权信息代表没有授权
        if( !window.sessionStorage.getItem('user') ) {
            const code = query('code')
            if( code ) {
                try {
                    Toast.show({
                        icon: 'loading',
                        duration: 0,
                        content: '加载中…'
                    })
                    const res:any = await getUserInfo(config.appid, {
                        code
                    })
                    Toast.clear()
                    window.sessionStorage.setItem('user',JSON.stringify(res?.data))
                    resolve(res?.data)
                } catch (error) {
                    // Toast.clear()
                    // Toast.show(`${error?.msg || '获取微信昵称失败!'}`)
                    // 没有code代表没有点击授权按钮 跳转授权弹框中转页授权
                    if( !!error?.msg && error?.msg === 'oauth_code已使用' ) {
                        const { origin, pathname, hash } = window.location
                        const url = encodeURIComponent(`${origin}${pathname}${hash}`)
                        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.appid}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
                    }
                    reject(error)
                }
            }else {
                // 没有code代表没有点击授权按钮 跳转授权弹框中转页授权
                const url = encodeURIComponent(window.location.href)
                window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.appid}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
            }
        }else {
            resolve(JSON.parse(window.sessionStorage.getItem('user')))
        }
    })
}

export default authorization


// 获取sdktoken
export const _getToken = async (jsApiList:any = [], openTagList:any = [], callback) => {
    try {
        const res: any = await getWxSdkToken(config.appid, {
            url: window.location.href
        })
        wx.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList, // 必填，需要使用的JS接口列表，所有JS接口列表见附录2,
            openTagList //需要使用的开放标签列表，例如['wx-open-launch-app']
        })
        wx.ready(callback)
        wx.error((error) => {
            console.log('报错了' + error || '--')
        })
    } catch (err) {
        Toast.clear()
    }
}